// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__2ShiT","row":"Option_row__UcV6u"};